package uz.ferro.erp.feature.product.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.model.DictItem

@Serializable
data class Region(
    val id: Long? = null,
    val key: String? = null,
    val name: DictItem? = null
)